import { Path } from '@lifaon/path';
import { RegExpEscape } from '../../misc/helpers/regexp-helpers';
export function EncodeURLPathForPath(path) {
    return path
        .replace(/:/g, '--colon--')
        .replace(/\*/g, '--asterisk--');
}
export function DecodePathForURLPath(path) {
    return path
        .replace(/--colon--/g, ':')
        .replace(/--asterisk--/g, '*');
}
export function NormalizeURLPath(path) {
    return DecodePathForURLPath(Path.of(EncodeURLPathForPath(path), Path.posix)
        .forceAbsolute('/')
        .toString());
}
export function ParseURLPath(path) {
    var params = [];
    var pattern = RegExpEscape(path)
        .replace(/\\\*\\\*$/g, '(?:.*?)$')
        .replace(/(^|\/):([^/]+)/g, function (substring) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (params.includes(args[1])) {
            throw new Error("Found a path having identical param's names '" + args[1] + "'");
        }
        else {
            params.push(args[1]);
        }
        return args[0] + '([^/]+)';
    });
    return {
        regExp: new RegExp("^" + pattern, ''),
        params: params
    };
}
//# sourceMappingURL=functions.js.map